import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { AuthGuard } from '@guards/auth.guard';
import { CashReInvestModalPageModule } from './cash-reinvest-modal/cash-reinvest-modal.module';
import { CashReInvestModalPage } from './cash-reinvest-modal/cash-reinvest-modal.page';
import { ProfilePage } from './profile.page';

const routes: Routes = [
  {
    path: '',
    component: ProfilePage,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CashReInvestModalPageModule,
    IonicModule,
    RouterModule.forChild(routes),
  ],
  entryComponents: [CashReInvestModalPage],
  declarations: [ProfilePage],
  exports: [ProfilePage],
})
export class ProfilePageModule {}
